/**
 * ModuleSection - Gjenbrukbar seksjon med tittel og innhold
 * Brukes for "Om modulen", "Funksjoner", etc.
 */
export function ModuleSection({ icon, title, children }) {
  return (
    <div>
      <h3 className="font-medium text-[var(--text-main)] mb-2 flex items-center gap-2">
        {icon && <span>{icon}</span>}
        {title}
      </h3>
      {children}
    </div>
  );
}

export default ModuleSection;
